import { IField, FieldsNames } from './ShippingWeightModal.types';

export const fields: IField[] = [
    { name: FieldsNames.name, label: 'Product Name' },
    { name: FieldsNames.unit, label: 'Unit of measure' },
    { name: FieldsNames.weight, label: 'Weight' },
];
